export default __webpack_public_path__ + "static/media/Calendar.ed39b36d.png";